import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../App.scss';
import PicoLoader from "../Common/PicoLoader";
import BackgroundImage from "../../../assets/images/ic_frame_mony_yellow.png";
import goldCoin from "../../../assets/images/ic_coin.png";
import silverCoin from "../../../assets/images/ic_silver_coin.png";
import SquareAvatar from "./SquareAvatar";

class Avatar extends React.Component{
    constructor() {
        super();
        this.state={
        }
    }
    render() {

        const {bought,id,price,stars,type,url}=this.props.data
        const avatarData={
            stars:stars,
            url:url,
            showStars:true
        }
        return (
            <Grid item sm={12} xs={12} alignItems={"center"} justify={'center'} container
                className='setting-avatar-dialog'
            >
                <SquareAvatar data={avatarData}/>
                {
                    (bought=='1') &&
                    <Grid container justify={"center"} alignItems={"center"}>
                        <p>
                            انتخاب
                        </p>
                    </Grid>
                }
                {
                    (price=='0' && bought=='0') &&
                    <Grid container justify={"center"} alignItems={"center"}>
                        <p>
                            رایگان
                        </p>
                    </Grid>
                }
                {
                    (price!='0' && bought!='1') &&
                    <Grid container justify={"center"} alignItems={"center"}>
                        <Grid sm={2} xs={2} container justify={"center"} alignItems={"center"}>
                            <p>
                                {price}
                            </p>
                        </Grid>
                        <Grid sm={2} xs={2} container justify={"center"} alignItems={"center"}>
                            <img className='setting-avatar-dialog-coin'
                                src={type=='silver'?silverCoin:goldCoin} alt=""/>
                        </Grid>
                    </Grid>
                }

            </Grid>
        )
    }

}
export default Avatar